import apiClient from './client';
import { endpoints } from './endpoints';
import type { TrainingConfig } from '@/types';

export const trainingConfigService = {
  async list(type: string | null = null): Promise<TrainingConfig[] | unknown> {
    const params = type ? { type } : {};
    const response = await apiClient.get(endpoints.trainingConfigs.list, { params });
    return response.data;
  },
  async getByType(type: string): Promise<unknown[]> {
    const response = await apiClient.get(endpoints.trainingConfigs.getByType(type));
    const data = response.data;
    return Array.isArray(data) ? data : (data as { data?: unknown[] })?.data ?? (data ? [data] : []);
  },
  async getById(id: string): Promise<unknown> {
    const response = await apiClient.get(endpoints.trainingConfigs.get(id));
    return response.data;
  },
  async create(configData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.post(endpoints.trainingConfigs.create, configData);
    return response.data;
  },
  async update(id: string, configData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.put(endpoints.trainingConfigs.update(id), configData);
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.trainingConfigs.delete(id));
    return response.data;
  },
};
